import { SxProps, useTheme } from "@mui/material";
import { CircleCheck, TriangleAlert } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "./Modal.component";

export const useModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [iconType, setIconType] = useState<"success" | "error" | "warning">("success");
  const [modalText, setModalText] = useState("");

  const { t }  = useTranslation();
  const theme = useTheme();

  const handleIcon = () => {
    switch (iconType) {
    case "success":
      return <CircleCheck color={ theme.customColors.exploreCardText } size={ "3rem" } />;
    case "error":
      return <TriangleAlert color={ theme.customColors.exploreCardText } size={ "3rem" } />;
    case "warning":
      return <TriangleAlert color={ theme.customColors.exploreCardText } size={ "3rem" } />;
    }
  };

  const renderModal = (sxStyle?: SxProps) => (
    <Modal
      description={ modalText ?? t("unexpected_error") }
      open={ showModal }
      title={
        modalText ?? t("error")
      }
      onClose={ ()=> {
        setShowModal(false);
        setModalText("");
      } }
      sxStyle={ sxStyle }
      icon={ handleIcon() }
    />
  );

  return {
    setShowModal,
    renderModal,
    setModalText,
    setIconType
  };
};
